export enum MeteringPeriod {
  INT = 'INT',

  DAY = 'DAY',

  RCY = 'RCY',
}
